import React from 'react';

import {Helmet} from 'views/module';

import CreateJob from 'views/scenes/career/job_create/CreateJob';

const JobCreate = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <CreateJob
      />
    </>
  );
};

export default JobCreate;
